export default __webpack_public_path__ + "static/media/DisneyPrincessBelle.60488e71.jpg";